/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import SvgIcon from "@mui/material/SvgIcon";

export const WaitingRoom = (props) => (
  <SvgIcon
    {...props}
    x="0px"
    y="0px"
    viewBox="0 0 100 125"
    enableBackground="new 0 0 100 100"
  >
    <g>
      <g>
        <path d="M78.64,13.938l-8.578,8.576l-5.203-5.202c-0.854-0.854-2.237-0.854-3.092,0c-0.854,0.854-0.854,2.238,0,3.093l6.749,6.748    c0.427,0.428,0.986,0.642,1.546,0.642s1.119-0.214,1.547-0.642L81.733,17.03c0.854-0.854,0.854-2.238,0-3.093    C80.879,13.083,79.494,13.083,78.64,13.938z" />
        <path d="M71.166,0C58.502,0,48.2,10.303,48.2,22.966c0,12.664,10.302,22.967,22.966,22.967c12.662,0,22.967-10.303,22.967-22.967    C94.133,10.303,83.828,0,71.166,0z M71.166,39.371c-9.047,0-16.404-7.358-16.404-16.405c0-9.046,7.357-16.404,16.404-16.404    c9.045,0,16.404,7.358,16.404,16.404C87.57,32.013,80.211,39.371,71.166,39.371z" />
        <circle cx="17.672" cy="11.356" r="9.842" />
        <path d="M58.495,55.039H36.156c-0.793,0-2.203-1.1-2.396-1.869l-5.589-22.238c-1.177-4.687-5.932-7.529-10.618-6.353    c-4.687,1.178-7.53,5.932-6.353,10.618l5.589,22.237c2.163,8.61,10.488,15.103,19.367,15.103h17.965v20.901    c0,3.623,2.937,6.562,6.562,6.562c3.624,0,6.562-2.938,6.562-6.562v-29.65C67.244,58.957,63.327,55.039,58.495,55.039z" />
        <path d="M45.047,76.912H34.22c-9.818,0-20.178-8.22-22.624-17.948L6.463,38.537c-0.442-1.759-2.229-2.832-3.981-2.382    c-1.757,0.44-2.824,2.224-2.382,3.981l5.134,20.428C8.406,73.196,21.411,83.474,34.22,83.474h10.827    c1.812,0,3.281-1.469,3.281-3.28C48.328,78.381,46.859,76.912,45.047,76.912z" />
      </g>
    </g>
  </SvgIcon>
);
